import { abmConstants } from "../constants";

const defaultState = {
  searchTerm: "",
  isFetching: false, 
  page: 0,
  count: 0,
  list: [],
  filterList: [],
  data: [],
  schema: null,
  item: {
    id: 0,
  },
  loaded: false,
  selectedTab: "propiedades",
  noSavedChanges: {
    state: false,
    values: {},
  },
  flow: null,
  cancel: {},
};


const procesarData = (payload, state) => {
  const { value, ...others } = payload;
  return  value ? {...state.item, ...value, ...Object.keys(others).reduce( (prev, curr)=> ({...prev, [curr]: others[curr].value}), {}) } : undefined;
} 

/**
 * @param {*} controller string | nombre del controller de la api 
 * @returns un reducer de operaciones asincronicas
 */
export const reducer = (controller) => (state = defaultState, {type, payload}) => {
  const redu = reducersObject(controller)[type] || reducersObject(controller).default;
  const newState = redu(state, payload);
  return newState;
}

const reducersObject = (controller) => {
  //console.log("dev.reducer", {state, type, payload});
  const constants = abmConstants(controller);
  return {
    [constants.SCHEMA_FORM.REQUEST]: (state, payload) => {
      return {
        ...state,
        isFetching: true, 
      };
    },
    [constants.SCHEMA_FORM.SUCCESS]: (state, payload) => {
      return {
        ...state,
        isFetching: false, 
      };      
    },
    [constants.SCHEMA_FORM.FAILURE]: (state, payload) => {
      return {
        ...state,
        isFetching: false, 
      }; 
    },
    [constants.SCHEMA.REQUEST]: (state, payload) => {
      return {
        ...state,
        isFetching: true, 
      };
    },
    [constants.SCHEMA.SUCCESS]: (state, payload) => {
      return {
        ...state,
        schema: payload,
        isFetching: false, 
      };      
    },
    [constants.SCHEMA.FAILURE]: (state, payload) => {
      return {
        ...state,
        schema: {fields: []},
        isFetching: false, 
      }; 
    },
    [constants.INDEX.REQUEST]: (state, payload) => {
      return {
        ...state,
        isFetching: true, 
      };
    },
    [constants.INDEX.SUCCESS]: (state, payload) => {
      return {
        ...state,
        list: payload.value,
        page: payload.page,
        count: payload.count,
        isFetching: false, 
      };      
    },
    [constants.INDEX.FAILURE]: (state, payload) => {
      return {
        ...state,
        list: [],
        page: 0,
        count: 0,
        isFetching: false, 
      };      
    },
    [constants.INDEX.UPDATE_ITEM]: (state, payload) => {
      //console.log(payload)
      if(!payload) return state;
      return {
        ...state,
        list: state.list.map(item => 
          (payload.value && payload.value.id) ? (item.id === payload.value.id ? payload.value : item) : (item.id === payload.id) ? payload : item
        )
      };      
    },
    [constants.INDEX.ADD_ITEM]: (state, payload) => {
      return {
        ...state,
        list: [payload, ...state.list],
        filterList: [payload, ...state.filterList],
      };      
    },
    [constants.LOAD_MORE.REQUEST]: (state, payload) => {
      return {
        ...state,
        isFetching: true, 
      };
    },
    [constants.LOAD_MORE.SUCCESS]: (state, payload) => {
      return {
        ...state,
        list: payload.value.reduce((prev, curr) => prev.find(item => item.id === curr.id) ? prev : [...prev, curr], state.list),
        page: payload.page,
        isFetching: false, 
      };      
    },
    [constants.LOAD_MORE.FAILURE]: (state, payload) => {
      return {
        ...state,
        isFetching: false, 
      };      
    },
    [constants.FILTER.REQUEST]: (state, payload) => {
      return {
        ...state,
        isFetching: true, 
      };
    },
    [constants.FILTER.SUCCESS]: (state, payload) => {
      return {
        ...state,
        filterList: payload.value || [],
        isFetching: false, 
      };      
    },
    [constants.FILTER.FAILURE]: (state, payload) => {
      return {
        ...state,
        filterList: [],
        isFetching: false, 
      };  
    },
    [constants.FILTER.CLEAR]: (state, payload) => {
      return {
        ...state,
        filterList: [],
      };       
    },
    [constants.FILTER.UPDATE_ITEM]: (state, payload) => {
      if(!payload) return state;
      return {
        ...state,
        filterList: state.filterList.map(item => 
          payload.id ? (item.id === payload.id ? payload : item) : (item.value && item.id === payload.value.id ? payload.value : item)
       ),
      }; 
    },
    [constants.GET_ITEM.REQUEST]: (state, payload) => {
      return {
        ...state,
        isFetching: true, 
      };
    },
    [constants.GET_ITEM.SUCCESS]: (state, payload) => {
      return {
        ...state,
        isFetching: false, 
      };      
    },
    [constants.GET_ITEM.FAILURE]: (state, payload) => {
      return {
        ...state,
        isFetching: false, 
      };  
    },
    [constants.GET_TIMELINE.REQUEST]: (state, payload) => {
      return {
        ...state,
        isFetching: true, 
        loaded: false,
      };
    },
    [constants.GET_TIMELINE.SUCCESS]: (state, payload) => {
      return {
        ...state,
        isFetching: false, 
        loaded: true,
        data: payload,
      };      
    },
    [constants.GET_TIMELINE.FAILURE]: (state, payload) => {
      return {
        ...state,
        isFetching: false, 
        loaded: false,
      };  
    },
    [constants.GET_ENUM.REQUEST]: (state, payload) => {
      return {
        ...state,
        isFetching: true, 
      };
    },
    [constants.GET_ENUM.SUCCESS]: (state, payload) => {
      return {
        ...state,
        isFetching: false, 
      };      
    },
    [constants.GET_ENUM.FAILURE]: (state, payload) => {
      return {
        ...state,
        isFetching: false, 
      };  
    },
    [constants.ADD_ITEM.REQUEST]: (state, payload) => {
      return {
        ...state,
        isFetching: true, 
      };
    },
    [constants.ADD_ITEM.SUCCESS]: (state, payload) => {
      return {
        ...state,
        //list: [payload, ...state.list],
        isFetching: false, 
      };      
    },
    [constants.ADD_ITEM.FAILURE]: (state, payload) => {
      return {
        ...state,
        isFetching: false, 
      };  
    },
    [constants.ADD_FORM.REQUEST]: (state, payload) => {
      return {
        ...state,
        loaded: false,
        isFetching: true, 
      };
    },
    [constants.ADD_FORM.SUCCESS]: (state, payload) => {
      return {
        ...state,
        isFetching: false, 
        loaded: true,
        item: payload.value,
      };      
    },
    [constants.ADD_FORM.FAILURE]: (state, payload) => {
      return {
        ...state,
        loaded: false,
        isFetching: false, 
      };  
    },
    [constants.EDIT_ITEM.REQUEST]: (state, payload) => {
      return {
        ...state,
        isFetching: true, 
      };
    },
    [constants.EDIT_ITEM.SUCCESS]: (state, payload) => {
      return {
        ...state,
        isFetching: false, 
        loaded: true,
        item: procesarData(payload, state) || state.item,
      }; 
    },
    [constants.EDIT_ITEM.FAILURE]: (state, payload) => {
      return {
        ...state,
        isFetching: false, 
      };  

    },
    [constants.EDIT_FORM.REQUEST]: (state, payload) => {

      try{
        state?.cancel?.editForm && state.cancel.editForm();
      }catch(e){
        console.log(e)
      }
      return {
        ...state,
        isFetching: true, 
        loaded: false,
        cancel: {
          ...state.cancel,
          editForm: payload 
        } 
      };
    },
    [constants.EDIT_FORM.SUCCESS]: (state, payload) => {
      return {
        ...state,
        isFetching: false, 
        loaded: true,
        item: procesarData(payload, state) || state.item,
      };
    },
    [constants.EDIT_FORM.FAILURE]: (state, payload) => {
      return {
        ...state,
        loaded: false,
        isFetching: false, 
      };  
    },
    [constants.REMOVE_ITEM.REQUEST]: (state, payload) => {
      return {
        ...state,
        isFetching: true, 
      };
    },
    [constants.REMOVE_ITEM.SUCCESS]: (state, payload) => {
      return {
        ...state,
        list: state.list.filter(x => x.id !== payload.id),
        filterList: state.filterList.filter(x => x.id !== payload.id),
        isFetching: false, 
      };
    },
    [constants.REMOVE_ITEM.FAILURE]: (state, payload) => {
      return {
        ...state,
        isFetching: false, 
      };  
    },
    [constants.LOADED_PROCESSED]: (state, payload) => {
      return {
        ...state,
        loaded: false,
      }
    },
    [constants.SET_SELECTED_TAB]: (state, payload) => {
      return {
        ...state,
        selectedTab: payload,
      }
    },
    [constants.SET_SEARCH_TERM]: (state, payload) => {
      return {
        ...state,
        searchTerm: payload,
      }
    },
    [constants.SET_NO_SAVED_CHANGES]: (state, payload) => {
      return {
        ...state,
        noSavedChanges: payload,
      }
    },
    [constants.SAVE_FLOW]: (state, payload) => {
      return{
        ...state,
        flow: payload,
      }
    },
    ["default"]: (state) => state,
  }
}

